import React from 'react';

const WebsiteActive = () => {
    return (
        <svg width={24.414} height={20} viewBox="0 0 24.414 20">
            <g transform="translate(0 -2)">
                <path
                    fill="none"
                    stroke="#8f99dc"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
                />
                <circle
                    fill="none"
                    stroke="#8f99dc"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    cx={4}
                    cy={4}
                    r={4}
                    transform="translate(4.5 3)"
                />
                <path
                    fill="none"
                    stroke="#8f99dc"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    d="M17 11l2 2 4-4"
                />
            </g>
        </svg>
    );
};

export default WebsiteActive;
